import { qz } from "../client";
import { createNamespaceMutation } from "../internal/createNamespaceMutation";
import { markPortClosed, markPortOpen, serialStore } from "./state";
import { type SerialOpenInput, type SerialSendInput } from "./types";

export const serialOpenPortMutationOptions = createNamespaceMutation({
  key: ["qz.serial.openPort"],
  run: async ({ options, port }: SerialOpenInput) => {
    await qz.serial.openPort(port, options);
    markPortOpen(port);
  },
  store: serialStore,
});

export const serialClosePortMutationOptions = createNamespaceMutation({
  key: ["qz.serial.closePort"],
  run: async (port: string) => {
    await qz.serial.closePort(port);
    markPortClosed(port);
  },
  store: serialStore,
});

export const serialSendDataMutationOptions = createNamespaceMutation({
  key: ["qz.serial.sendData"],
  run: async ({ data, options, port }: SerialSendInput) => {
    await qz.serial.sendData(port, data, options);
  },
  store: serialStore,
});
